import { createSlice } from '@reduxjs/toolkit';
import { PermissionsListStateType } from 'src/types/permissionsList';

const initialState: PermissionsListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const permissionsListSlice = createSlice({
    name: 'permissionsList',
    initialState,
    reducers: {
        getPermissionsListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getPermissionsListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getPermissionsListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getPermissionsListFetch,
    getPermissionsListFetchSuccess,
    getPermissionsListFetchFailure,
} = permissionsListSlice.actions;

export default permissionsListSlice.reducer;
